import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ILoadingState } from 'src/components/common/types/loadingTypes';

const initialState: ILoadingState = {
	loadingStates: {},
};

export const loadingSlice = createSlice({
	name: 'loading',
	initialState,
	reducers: {
		setLoading: (
			state,
			action: PayloadAction<{ key: string; loading: boolean }>,
		) => {
			const { key, loading } = action.payload;
			state.loadingStates[key] = loading;
		},
	},
});

export const { setLoading } = loadingSlice.actions;

export const selectIsLoading = (state: { loading: ILoadingState }) =>
	Object.values(state.loading.loadingStates).some((loading) => loading);

export const loadingReducer = loadingSlice.reducer;
